import { CrossIcon } from '@mentimeter/ragnar-visuals';
import * as React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Clickable } from '@mentimeter/ragnar-ui/clickable';
import { useConfig } from '../../data-mediation';
import { usePresentationActions } from '../../misc/presentation-actions';
import { Hotkey } from '../../misc/hotkeys/Hotkey';
import { useFullscreen } from '../../data-mediation/fullscreen';

const UseExitEnabled = () => {
  const { mode } = useConfig();

  const exitable = mode === 'live';
  const disabled = mode === 'preview';

  return { exitable, disabled };
};

export const Exit = () => {
  const { exitable, disabled } = UseExitEnabled();
  const { exitPresentation } = usePresentationActions();
  const { exitPresentationAndFullscreen } = useFullscreen();

  return (
    <Box p="space0.5" borderRadius="full" bg="transparent">
      <Clickable
        aria-label="Exit presentation"
        onClick={exitPresentationAndFullscreen}
        disabled={disabled}
        borderRadius="full"
        p="space4"
        color="primary"
        extend={({ theme }) => ({
          opacity: 1,
          '@media (hover: hover)': {
            ':hover': {
              opacity: 1,
              backgroundColor:
                !disabled && theme.colors.surfaceOverlayTransparentHover,
              color: !disabled && theme.colors.primary,
            },
          },
          ':focus-visible': {
            zIndex: 3,
            backgroundColor:
              !disabled && theme.colors.surfaceOverlayTransparentHover,
            color: !disabled && theme.colors.primary,
          },
        })}
      >
        <CrossIcon color="inherit" />
      </Clickable>
      {exitable && (
        <>
          <Hotkey keyCode="p" action={exitPresentationAndFullscreen} />
          <Hotkey keyCode="escape" action={exitPresentation} />
        </>
      )}
    </Box>
  );
};
